import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getUser } from '@frontend/auth-helpers';
import { useSchedulingLocationInfo } from '../../../../hooks/use-scheduling-location-info';
import { useCalendarLocationIds } from '../../../../stores/calendar-location.store';
import { useCalendarStore } from '../../../../stores/calendar.store';
import { DragPendoEventEntryPoints } from '../../constants';
import { useColumnEntityReorderStore } from '../../providers';

export const usePendoTrackingForDragDrop = ({
  eventName,
  entryPoint,
}: {
  eventName: SchedulerV3.Types.PendoTrackingEventName;
  entryPoint?: DragPendoEventEntryPoints;
}) => {
  const userId = getUser()?.userID || '';
  const { selectedOrgId } = useSchedulingLocationInfo();
  const { calendarLocationIds } = useCalendarLocationIds();
  const { calendarEntityType } = useCalendarStore(['calendarEntityType']);
  const { isInReorderMode } = useColumnEntityReorderStore(['isInReorderMode']);

  const trackPendoEvent = () => {
    if (eventName === 'schedule_column_reordered' && isInReorderMode) {
      return;
    }
    const trackingData = {
      organizationId: selectedOrgId,
      locationIds: calendarLocationIds,
      userId,
      scheduleView: calendarEntityType,
      ...(entryPoint && { entryPoint }),
    };
    SchedulerV3.trackPendoEvent(eventName, trackingData);
  };
  return trackPendoEvent;
};
